<div class="min-h-screen mx-auto px-4 flex flex-col"
     *ngIf="config"
     [class.max-w-5xl]="config.screenRatio < 1"
     [class.max-w-xl]="config.screenRatio >= 1"
>
  <div id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo">
  </div>

  <content-block [slug]="'default-capture-top'" id="default-home-top-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-web-booth-top'" id="wbm-web-booth-top-wrapper" [class.hidden]=" ! boothMode"></content-block>

  <div id="camera-viewport" class="aspect-square relative md:w-2/3 md:mx-auto" *ngIf=" ! previewScreen || (previewScreen && config.numInputImages == 1)">
    <ng-container *ngIf=" ! previewScreen">
      <konvas
        class="w-full aspect-square rounded-lg block absolute z-10"
        [class.-rotate-90]="rotate == 270"
        [class.rotate-90]="rotate == 90"
        [class.rotate-180]="rotate == 180"
        [videoContainer]="videoContainer"
        [class.hidden]=" ! (state === Lifecycle.CAPTURING || state === Lifecycle.CAPTURING_TRIGGERED)"
      ></konvas>
      <div class="w-full aspect-square absolute z-10 items-center justify-center flex flex-col text-2xl" *ngIf="config.enablePoseOverlay && (state === Lifecycle.CAPTURING || state === Lifecycle.CAPTURING_TRIGGERED)">
        <img src="/assets/images/pose1.png" alt="Pose Overlay" class="aspect-square w-full">
      </div>
      <div class="w-full aspect-square absolute z-20" id="camera-icon-wrapper" *ngIf="state === Lifecycle.CAPTURING && hasMoreThanOneCamera()">
        <button type="button" class="absolute top-1 right-1 text-3xl"><fa-icon [icon]="faCameraRotate" (click)="changeCamera($event)"></fa-icon></button>
      </div>
      <div *ngIf="counter > 0" id="counter-wrapper" class="w-full aspect-square absolute z-30 items-center justify-center flex text-9xl font-bold [text-shadow:_0_0_8px_rgb(0_0_0_)]">{{ counter }}</div>
      <div class="w-full aspect-square absolute z-40 items-center justify-center flex text-2xl" *ngIf="state === Lifecycle.INIT">
        <span class="camera-loading-text" i18n>Camera Loading ...</span>
      </div>
      <div class="w-full aspect-square absolute z-40 items-center justify-center flex flex-col text-2xl" *ngIf="state === Lifecycle.CAPTURED_UPLOADING">
        <img src="/assets/images/Pulse-1s-200px.gif" alt="uploading" class="w-12 aspect-square m-6">
        <span class="uploading-text" i18n>Uploading ...</span>
      </div>
      <div class="w-full aspect-square absolute z-40 items-center justify-center flex flex-col text-2xl" *ngIf="state === Lifecycle.CAPTURED_PROCESSING">
        <img src="/assets/images/Pulse-1s-200px.gif" alt="uploading" class="w-12 aspect-square m-6">
        <span class="processing-text" i18n>Processing ...</span>
      </div>
      <div class="w-full aspect-square absolute z-40 items-center justify-center flex flex-col text-2xl" *ngIf="state === Lifecycle.CAPTURED">
        <img src="/assets/images/Pulse-1s-200px.gif" alt="uploading" class="w-12 aspect-square m-6">
        <span class="processing-text" i18n>Processing ...</span>
      </div>
      <div class="w-full aspect-square absolute z-40 items-center justify-center flex flex-col text-2xl" *ngIf="state === Lifecycle.ERROR">

        <div id="alert-additional-content-2" class="p-4 mb-4 border rounded-lg bg-gray-800 text-red-400 border-red-800" role="alert">
          <div class="flex items-center">
            <svg class="flex-shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
            </svg>
            <span class="sr-only">Info</span>
            <h3 class="text-xl font-medium" *ngIf=" ! captchaFailed && ! serverError" i18n>Internet Connection Error!</h3>
            <h3 class="text-xl font-medium" *ngIf="captchaFailed" i18n>Security Error (Captcha)!</h3>
            <h3 class="text-xl font-medium" *ngIf="serverError" i18n>Server Error!</h3>
          </div>
          <div class="mt-2 mb-4 text-lg">
            <p i18n>Unable to submit request.</p>
            <p *ngIf=" ! captchaFailed && ! serverError" i18n>You are likely seeing this error due to a network issue.</p>
            <p *ngIf=" ! captchaFailed && ! serverError" i18n>Please check your internet connection and try again.</p>
            <p *ngIf="captchaFailed" i18n>You are likely to see this error due to recaptcha unable to verify you are not a robot.</p>
            <p *ngIf="captchaFailed" i18n>If you are using IPad please make sure you change this setting.</p>
            <p *ngIf="captchaFailed" i18n>Go to Settings  > [your name] > Sign-In & Security, then turn Automatic Verification on or off.</p>
            <p *ngIf="serverError" i18n>You are likely to see this error due to server error. Please contact support!</p>
          </div>
          <div class="flex">
            <button
              type="button"
              routerLink="../home"
              class="text-white bg-red-800 hover:bg-red-900 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-xl px-3 py-1.5 me-2 text-center inline-flex items-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
              <svg class="me-2 h-3 w-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 14">
                <path d="M10 0C4.612 0 0 5.336 0 7c0 1.742 3.546 7 10 7 6.454 0 10-5.258 10-7 0-1.664-4.612-7-10-7Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>
              </svg>
              <span i18n>Start Again</span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <div *ngIf="previewScreen && config.numInputImages == 1">
      <img [src]="toUrl(images[0])" alt="Preview" />
    </div>
  </div>

  <content-block class="md:w-2/3 md:mx-auto" *ngIf=" ! previewScreen && (state === Lifecycle.CAPTURING || state === Lifecycle.CAPTURING_TRIGGERED) && images.length == 0" [slug]="'default-capture-bottom-1'" id="default-capture-bottom-1-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block class="md:w-2/3 md:mx-auto" *ngIf=" ! previewScreen && (state === Lifecycle.CAPTURING || state === Lifecycle.CAPTURING_TRIGGERED) && images.length == 1" [slug]="'default-capture-bottom-1a'" id="default-capture-bottom-1a-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block class="md:w-2/3 md:mx-auto" *ngIf=" ! previewScreen && (state === Lifecycle.CAPTURING || state === Lifecycle.CAPTURING_TRIGGERED) && images.length == 2" [slug]="'default-capture-bottom-1b'" id="default-capture-bottom-1b-wrapper" [class.hidden]="boothMode"></content-block>

  <content-block class="md:w-2/3 md:mx-auto" *ngIf="previewScreen" [slug]="'default-capture-bottom-2'" id="default-capture-bottom-2-wrapper" [class.hidden]="boothMode"></content-block>

  <content-block class="md:w-2/3 md:mx-auto" *ngIf=" ! previewScreen && (state === Lifecycle.CAPTURING || state === Lifecycle.CAPTURING_TRIGGERED) && images.length == 0" [slug]="'wbm-web-booth-bottom-1'" id="wbm-web-booth-bottom-1-wrapper" [class.hidden]=" ! boothMode"></content-block>
  <content-block class="md:w-2/3 md:mx-auto" *ngIf=" ! previewScreen && (state === Lifecycle.CAPTURING || state === Lifecycle.CAPTURING_TRIGGERED) && images.length == 1" [slug]="'wbm-web-booth-bottom-1a'" id="wbm-web-booth-bottom-1a-wrapper" [class.hidden]=" ! boothMode"></content-block>
  <content-block class="md:w-2/3 md:mx-auto" *ngIf=" ! previewScreen && (state === Lifecycle.CAPTURING || state === Lifecycle.CAPTURING_TRIGGERED) && images.length == 2" [slug]="'wbm-web-booth-bottom-1b'" id="wbm-web-booth-bottom-1b-wrapper" [class.hidden]=" ! boothMode"></content-block>

  <content-block class="md:w-2/3 md:mx-auto" *ngIf="previewScreen" [slug]="'wbm-web-booth-bottom-2'" id="wbm-web-booth-bottom-2-wrapper" [class.hidden]=" ! boothMode"></content-block>


  <div class="flex flex-col py-3 md:w-2/3 md:mx-auto" *ngIf=" ! previewScreen && (state === Lifecycle.CAPTURING || state === Lifecycle.CAPTURING_TRIGGERED)">

    <button type="button" class="button-primary my-3" (click)="take()" id="take-photo-button">Take photo</button>

    <ng-container *ngIf="config.enableUploadButton">
      <input type="file" class="hidden" (change)="onFileSelected($event)" #fileUpload accept="image/*" />
      <button type="button" class="button-secondary my-3"
              (click)="fileUpload.click()"
              [disabled]="state === Lifecycle.CAPTURING_TRIGGERED"
              id="upload-photo-button"
              i18n
      >Upload photo</button>
    </ng-container>
  </div>

  <div class="flex flex-col py-3 md:w-2/3 md:mx-auto" *ngIf="previewScreen && config.numInputImages == 1">
    <button type="button"
            class="button-primary my-3"
            id="accept-photo-button"
            i18n
            (click)="accept()">Accept</button>

      <button type="button"
              class="button-secondary my-3"
              id="retake-photo-button"
              i18n
              (click)="retake()"
      >Re-Take</button>
  </div>

  <div *ngIf="config.numInputImages > 1" class="flex flex-row justify-center">
    <ng-container *ngFor="let img of images; index as i">
      <div>
        <img class="h-auto max-w-full rounded-lg bg-neutral-950 w-32 mx-1 cursor-pointer" [src]="toUrl(img)" (click)="retake(i)"/>
      </div>
    </ng-container>
  </div>

  <div class="flex flex-col py-3 md:w-2/3 md:mx-auto" *ngIf="previewScreen && config.numInputImages > 1">
    <button type="button"
            class="button-primary my-3"
            id="accept-photo-button"
            i18n
            (click)="accept()">Accept</button>
    <content-block class="md:w-2/3 md:mx-auto text-center mt-3" [slug]="'default-capture-bottom-3'" id="default-capture-bottom-3-wrapper" [class.hidden]="boothMode"></content-block>
    <content-block class="md:w-2/3 md:mx-auto text-center mt-3" [slug]="'wbm-web-booth-bottom-3'" id="wbm-web-booth-bottom-3-wrapper" [class.hidden]=" ! boothMode"></content-block>
  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-disclaimer-bottom'" id="wbm-disclaimer-bottom-wrapper" [class.hidden]=" ! boothMode"></content-block>
</div>
